import React from 'react';
import get_bundle from '../../domain/get_bundle';
import Amount from '../../domain/Amount';
import Locale from '../../domain/Locale';
import Color from '../../domain/Color';
import User from '../../domain/User';
import StdTable from '../StdTable';
import StdCustomPayment from '../StdCustomPayment';
import DefaultUi from '../DefaultUi';
import Alert from '../Alert';
import HTMLComponent from '../HTMLComponent';
import MarkdownComponent from '../MarkdownComponent';
import PurchasePaymentGateway from '../PurchasePaymentGateway';
import PurchaseStripeGateway from '../PurchaseStripeGateway';
import PurchaseStripeScaGateway from '../PurchaseStripeScaGateway'
import PurchasePaymentUrl from '../PurchasePaymentUrl';
import t from 'tcomb-form';
import { props } from 'tcomb-react';
import template from 'lodash/string/template';

const FormType = t.struct({
      madaiCoupon: t.Str
    }, 'madaiCoupon');

@props({
  locale: Locale,
  purchase: t.Obj,
  pending_purchase_message: t.maybe(t.Str),
  user: User,
  goAccount: t.Func,
  goChangePassword: t.Func,
  goPurchases: t.Func,
  doLogout: t.Func,
  doAcceptCookies: t.Func,
  message: t.maybe(t.ReactElement),
  share_purchase: t.maybe(t.ReactElement),
  custom_payments: t.maybe(t.list(t.Obj)),
  themeBtnColor: t.maybe(Color),
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  doSendGiftCardCode: t.Func
})
export default class Purchase extends React.Component {

  constructor(...args){
    super(...args);
    this.state = {
      options: this.getOptions()
    };
  }

  getStatus() {
    return this.props.purchase.status;
  }

  isPending() {
    return this.getStatus() === 'PENDING';
  }

  isPaid() {
    return this.getStatus() === 'PAID';
  }

  isShipped() {
    return this.getStatus() === 'SHIPPED';
  }

  isCanceled() {
    return this.getStatus() === 'SHIPPED';
  }

  hasInvoice() {
    return (this.props.purchase.invoice);
  }

  hasGiftCardCodeAssigned() {
    return (this.props.purchase.gift_card_code !== null);
  }

  showGiftCardForm() {
    return (!this.props.purchase.gift_card_not_supported && this.isPending() && !this.hasGiftCardCodeAssigned());
  }

  getTotal() {
    return  this.props.purchase.amount + (this.props.purchase.domicile ? this.props.purchase.domicile.shipping.cost : 0);
  }

  getTotalLabel(bundle) {
    return t.Num.is(this.props.purchase.payment_amount) ? bundle.summary.total : bundle.summary.payment_total;
  }

  getPaymentMessage() {
    const bundle = get_bundle(this.props.locale).template_message;
    if (this.isPending()) {
        if (this.props.pending_purchase_message) {
          return <Alert type={'warning'}><MarkdownComponent>{this.props.pending_purchase_message}</MarkdownComponent></Alert>;
        }
        else {
          return <Alert type={'warning'}><MarkdownComponent>{bundle['purchase.PENDING']}</MarkdownComponent></Alert>;
        }
    } else if (this.isPaid() || this.isShipped()) {
      return <Alert type={'success'}><MarkdownComponent>{bundle['purchase.PAID']}</MarkdownComponent></Alert>;
    } else if (this.isCanceled()) {
      return <Alert type={'error'}><MarkdownComponent>{bundle['purchase.CANCELED']}</MarkdownComponent></Alert>;
    } else {
      return null;
    }
  }

  getSummaryRows() {
    const { locale, purchase } = this.props;
    const bundle = get_bundle(this.props.locale).order;

    const total = this.getTotal();

    let summary_rows = [
      [bundle.summary.price, Amount.format(locale, purchase.currency, purchase.amount)],
      [bundle.summary.shipping, Amount.format(locale, purchase.currency, purchase.domicile ? purchase.domicile.shipping.cost : 0)],
      [this.getTotalLabel(bundle), Amount.format(locale, purchase.currency, total)]
    ];
    if (t.Num.is(purchase.payment_amount)) {
      let gift_card_discount = total - purchase.payment_amount;
      summary_rows.push(
        [bundle.summary.gift_card_discount, ' - ' + Amount.format(locale, purchase.currency, gift_card_discount)], [bundle.summary.payment_total, Amount.format(locale, purchase.currency, purchase.payment_amount)]
      );
    }
    return summary_rows;
  }

  getSummary() {
    return (
      <div id='summary'>
        <h3>{get_bundle(this.props.locale).order.summary.title}</h3>
        <StdTable>{this.getSummaryRows()}</StdTable>
      </div>
    );
  }

  getDetailRows(bundle) {
    return [
      [bundle.summary.id, this.props.purchase.id],
      [bundle.summary.tick, this.props.locale.format_date(this.props.purchase.tick)],
      [bundle.summary.product, this.props.purchase.product],
      [bundle.summary.quantity, '1']
    ];
  }

  getDetail() {
    const bundle = get_bundle(this.props.locale).order;
    return (
      <div>
        <h3>{bundle.summary.details_title}</h3>
        <StdTable>{this.getDetailRows(bundle)}</StdTable>
      </div>
     );
  }

  getCustomPayments() {
    return this.props.custom_payments.map((custom_payment, index) => {
      return <StdCustomPayment key={index} description={custom_payment.purchase_description} image={custom_payment.image} />;
    });
  }

  getPaymentGateways() {
    return this.props.purchase.payment.gateways.map((gateway, index) => {
      if (gateway.type === 'stripe') {
        //return null 
        return <PurchaseStripeGateway key={index} html={gateway.html}>{get_bundle(this.props.locale).payment[gateway.type]}</PurchaseStripeGateway>;
      }
      else if (gateway.type === 'stripe_sca') {
        var stripe_sca = JSON.parse(gateway.html)
        console.log(stripe_sca)
        return <PurchaseStripeScaGateway key={index} stripe_sca={stripe_sca}>{get_bundle(this.props.locale).payment['stripe']}</PurchaseStripeScaGateway>; 
      }
      else {
        return <PurchasePaymentGateway key={index} html={gateway.html}>{get_bundle(this.props.locale).payment[gateway.type]}</PurchasePaymentGateway>;
      }
    });
  }

  getPaymentUrl() {
    return <PurchasePaymentUrl url={this.props.purchase.payment.url} label={get_bundle(this.props.locale).go_payment} />;
  }

  getPayment() {
    if (this.props.purchase.payment) {
      if (this.props.purchase.payment.gateways) {
        return this.getPaymentGateways();
      }
      else {
        return this.getPaymentUrl();
      }
    }
    return null;
  }

  getPaymentsSection(bundle) {
    if (!this.isPending()) {
      return null;
    }

    return (
      <div>
        <h3>{bundle.payment}</h3>
        {this.getCustomPayments()}
        {this.getPayment()}
      </div>
    );
  }

  getDomicilieRows(domicile) {
    const bundle = get_bundle(this.props.locale).order.domicile;
    return [
      [bundle.name, domicile.name],
      [bundle.surname, domicile.surname],
      [bundle.address, domicile.address],
      [bundle.co, domicile.co],
      [bundle.town, domicile.town],
      [bundle.district, domicile.district],
      [bundle.zip, domicile.zip],
      [bundle.country, this.props.locale.display_country(domicile.shipping.country)],
      [bundle.email, domicile.email],
      [bundle.mobile, domicile.mobile],
      [bundle.alt_email, domicile.alt_email],
      [bundle.alt_mobile, domicile.alt_mobile]
    ];
  }

  getCouponRows(coupon) {
    const bundle = get_bundle(this.props.locale).order.domicile;
    return [
      [bundle.name, coupon.name],
      [bundle.surname, coupon.surname],
      [bundle.email, coupon.email],
      [bundle.mobile, coupon.mobile]
    ];
  }

  getContact() {
    const bundle = get_bundle(this.props.locale).order;
    if (this.props.purchase.domicile) {
      return (
        <div>
          <h3>{bundle.domicile.title}</h3>
          <StdTable>{this.getDomicilieRows(this.props.purchase.domicile)}</StdTable>
        </div>
        );
      }
      else if (this.props.purchase.coupon) {
      return (
        <div>
          <h3>{bundle.coupon.title}</h3>
          <StdTable>{this.getCouponRows(this.props.purchase.coupon)}</StdTable>
        </div>
      );
    }
  }

  getInvoice() {
    const bundle = get_bundle(this.props.locale).order;
    if (!this.props.purchase.invoice) {
      return null;
    }

    return (
      <div>
        <h3>{bundle.invoice.title}</h3>
        <StdTable>{this.getInvoiceRows(this.props.purchase.invoice)}</StdTable>
      </div>
    );
  }

  getInvoiceRows(invoice) {
    const bundle = get_bundle(this.props.locale).order;
    return [
      [bundle.invoice.name, invoice.name],
      [bundle.invoice.vat, invoice.vat],
      [bundle.invoice.address, invoice.address],
      [bundle.invoice.town, invoice.town],
      [bundle.invoice.district, invoice.district],
      [bundle.invoice.zip, invoice.zip]
    ];
  }

  getGiftCardSection(bundle) {
    const btnStyle = {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };
    if (this.hasGiftCardCodeAssigned()) {
      return (
        <div>
          <h3>{bundle.gift_card.assigned_title}</h3>
          <HTMLComponent>
            {
              template(bundle.gift_card.assigned)({
                gift_card_code: this.props.purchase.gift_card_code
              })
            }
          </HTMLComponent>
        </div>
      );
    }
    else if (this.showGiftCardForm()) {
      return (
        <div>
          <h3>{bundle.gift_card.title}</h3>
          <form onSubmit={this.onSubmit}>
            <t.form.Form
              ref='form'
              type={FormType}
              options={this.state.options}/>
            <button className='btn' style={btnStyle}>{bundle.gift_card.do_send_gift_card_code}</button>
          </form>
        </div>
      );
    }
  }

  getOptions() {
    const bundle = get_bundle(this.props.locale).order;
    return {
      fields: {
        madaiCoupon: {
          label: bundle.gift_card.label,
          help: bundle.gift_card.hint
        }
      }
    };
  }

  onSubmit = (evt) => {
    evt.preventDefault();
    const value = this.refs.form.getValue();
    if (value) {
      this.props.doSendGiftCardCode(value.madaiCoupon);
    }
  }

  render() {

    const { locale } = this.props;
    const bundle = get_bundle(locale).order;

    return (
      <DefaultUi id='purchase' title={bundle.title} themeBgColor={this.props.themeBgColor} themeBgFontColor={this.props.themeBgFontColor}>
        <div className='cols'>
          <div className='large-100'>
            <div className='cell'>
              {this.props.message}
              {this.getPaymentMessage()}
              {this.getSummary()}
              {this.getPaymentsSection(bundle)}
              {this.getGiftCardSection(bundle)}
              <hr />
              {this.getDetail()}
              {this.getContact()}
              {this.getInvoice()}
              {this.props.share_purchase}
            </div>
          </div>
        </div>
      </DefaultUi>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/content/Purchase.js
 **/